module.exports = __webpack_public_path__ + "media/images/top/idea-item02-a718d4cdf2c0933a82cd9336155d627e.webp";